module.exports = __webpack_public_path__ + "static/media/who-we-are.b8548cc7.svg";